<label [ngClass]="labelClass">{{ label }}</label>
<ng-container *ngIf="hasContextMenu;else withoutContextMenu">
    <ng-container *ngTemplateOutlet="withContextMenu"></ng-container>
</ng-container>

<ng-template #withContextMenu>
    <p-tree [value]="items"
            selectionMode="single"
            [(selection)]="node"
            [contextMenu]="cm"
            (onNodeContextMenuSelect)="onContextMenuOpen($event)">
        <ng-template let-node pTemplate="default">
            <div [innerText]="node.label" style="width: 100%;"></div>
        </ng-template>
    </p-tree>

    <app-context-menu #cm [contextMenuItems]="contextMenuItems"></app-context-menu>
</ng-template>

<ng-template #withoutContextMenu>
    <p-tree [value]="items"
            selectionMode="single"
            [(selection)]="node">
        <ng-template let-node pTemplate="default">
            <div [innerText]="node.label" type="text" #contextModel style="width:100%"></div>
        </ng-template>
    </p-tree>
</ng-template>
